export const getPageNumbers = (currentPage: number, lastPage: number) => {
  return [
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
  ].filter((n) => n >= 0 && n <= lastPage)
}
